import { STUDY_ROUTE_NAME } from './study.router'

const CampList = () =>
  import(/* webpackChunkName: "camp" */ '../../pages/trainingCamp/List.vue')
const CampDetail = () =>
  import(/* webpackChunkName: "camp" */ '../../pages/trainingCamp/Detail.vue')
const CampForbidden = () =>
  import(
    /* webpackChunkName: "camp" */ '../../pages/trainingCamp/forbidden.vue'
  )
const PeriodList = () =>
  import(
    /* webpackChunkName: "camp" */ '../../pages/trainingCamp/PeriodList.vue'
  )
const LearningStatistics = () =>
  import(
    /* webpackChunkName: "LearningStatistics" */ '@/pages/study/record/learningStatistics.vue'
  )
const RecordList = () =>
  import(/* webpackChunkName: "record" */ '../../pages/study/record/List.vue')
const RecordPoster = () =>
  import(
    /* webpackChunkName: "record" */ '../../pages/study/record/StudyPoster.vue'
  )
const GiftRecord = () =>
  import(
    /* webpackChunkName: "record" */ '../../pages/study/record/GiftRecord.vue'
  )
export default [
  {
    path: '/camp/list',
    meta: { title: '训练营' },
    component: CampList,
  },
  {
    name: STUDY_ROUTE_NAME.CampDetail,
    path: '/camp/detail',
    meta: { title: '' },
    component: CampDetail,
  },
  {
    path: '/period/list',
    meta: { title: '训练营营期' },
    component: PeriodList,
  },
  {
    path: '/camp/forbidden',
    meta: { title: '访问权限' },
    component: CampForbidden,
  },
  {
    path: '/study/situation',
    meta: { title: '学习统计' },
    component: LearningStatistics,
    name: STUDY_ROUTE_NAME.LEARNING_STATISTICS,
  },
  {
    path: '/study/record',
    meta: { title: '学习记录' },
    component: RecordList,
  },
  {
    path: '/study/poster',
    meta: { title: '学习情况' },
    component: RecordPoster,
  },
  {
    path: '/gift/record',
    meta: { title: '赠送记录' },
    component: GiftRecord,
  },
]
